import DOMPurify from 'dompurify';

import { tw } from '../../utils';

interface RenderHTMLProps {
  content: string;
  className?: string;
}

export const RenderHTML: React.FC<RenderHTMLProps> = ({
  content,
  className,
}: RenderHTMLProps) => {
  const createMarkup = (html: string) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  return (
    <div
      className={tw(className ? className : 'rich-text')}
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  );
};
